import { CheckBoxFieldType } from "shared/types";
import "styles/components/forms/inputs/checkboxInput.css";

const CheckboxInput = ({
  id,
  label,
  className,
  required,
  type,
  value = false,
}: CheckBoxFieldType) => {
  return (
    <div key={id} className="checkbox-container">
      <input
        className={className}
        name={id}
        required={required}
        type={type}
        id={id}
        defaultChecked={value}
      />
      <label htmlFor={id} className={className}>
        {label}
      </label>
    </div>
  );
};

export default CheckboxInput;
